export class ProductoPresentacionId {
    codigoProductoPresentacion: number;
    codigoProducto: number;
    codigoPresentacion: number;
    codigoMarca: number;
}